// extracted by mini-css-extract-plugin
export default {"purpleLink":"ald_button__purpleLink__SP7rl","moveLeft":"ald_button__moveLeft__CJ8p7","moveRight":"ald_button__moveRight__DmLX3"};